export const clear = (isOldSDK = false) => {
	if (isOldSDK) {
		window.myTSAccountProtection.clearUser()
	} else {
		window.tsPlatform.drs.clearUser()
	}
}
